// extracted by mini-css-extract-plugin
export default {"fullscreen":"DocModal_fullscreen__r27IY"};